import { TextHFiveIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Heading5 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextHFiveIcon size={Sizes[size]} {...rest} color={fill} />;
};

Heading5.displayName = 'Heading5';
